/*
 *
 * ManageVasPopup
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 3-Mar-2025
 */

import { connect } from 'react-redux'
import ManageVasPopup from './ManageVasPopup'
import * as actionLayer from 'Route/TerminalsManagement/modules/TerminalsManagementActions'
import { userPermissions } from 'Store/selectors'
import { doPopup } from 'Store/actions/popup'
import * as userActions from 'Store/actions/user'
import { bindActionCreators } from 'redux'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch),
  ...bindActionCreators(userActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.popup?.popupData || {},
  isUpdatingVas: state?.loading?.local_manageVas || false,
  userPermissions: userPermissions(state)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ManageVasPopup)
